import { render, staticRenderFns } from "./sendGoods.vue?vue&type=template&id=5d49bada&scoped=true"
import script from "./sendGoods.vue?vue&type=script&lang=js"
export * from "./sendGoods.vue?vue&type=script&lang=js"
import style0 from "./sendGoods.vue?vue&type=style&index=0&id=5d49bada&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d49bada",
  null
  
)

export default component.exports